import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export default api;

export const fileUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http") || path.startsWith("data:")) return path;
  if (path.startsWith("/api")) return `${BACKEND_URL}${path}`;
  return `${API_URL}/files/${path}`;
};

export const CATEGORIES = [
  { slug: "vehicles", name: "Vehicles", icon: "Car" },
  { slug: "real-estate", name: "Real Estate", icon: "Home" },
  { slug: "jobs", name: "Jobs", icon: "Briefcase" },
  { slug: "electronics", name: "Electronics", icon: "Cpu" },
  { slug: "furniture", name: "Furniture", icon: "Armchair" },
  { slug: "services", name: "Services", icon: "Wrench" },
  { slug: "pets", name: "Pets", icon: "PawPrint" },
  { slug: "fashion", name: "Fashion", icon: "Shirt" },
];

export function formatPrice(n, currency) {
  if (n == null) return "See description";
  const cur = (currency || "USD").toUpperCase();
  if (n === 0) return "FREE";
  const symbol = cur === "CAD" ? "CA$" : "$";
  const suffix = cur === "CAD" ? " CAD" : " USD";
  return `${symbol}${Number(n).toLocaleString()}${suffix}`;
}

export const isFeatured = (l) => Boolean(l?.featured && l.featured_until && new Date(l.featured_until) > new Date());

const DAY_MS = 86400000;
export const isExpired = (l) => l?.status === "expired" || (l?.expires_at && new Date(l.expires_at) <= new Date());
export const daysLeft = (l) => Math.max(0, Math.ceil((new Date(l.expires_at) - new Date()) / DAY_MS));
export const canRepost = (l) => isExpired(l) || daysLeft(l) <= 7;

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const diffMs = now - d;
  const diffH = diffMs / (1000 * 60 * 60);
  if (diffH < 1) return `${Math.max(1, Math.floor(diffMs / 60000))}m ago`;
  if (diffH < 24) return `${Math.floor(diffH)}h ago`;
  if (diffH < 24 * 7) return `${Math.floor(diffH / 24)}d ago`;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
